import { useEffect, useState } from 'react'

/**
 * Tracks whether `window.innerWidth` is at or below `breakpoint`.
 *
 * Re-evaluates on every `resize` event. SSR-safe: returns `false` when `window`
 * is unavailable (e.g. during tests with `jsdom` not yet loaded).
 *
 * Default breakpoint matches the ProfileContainer mobile threshold (1024 px).
 * Pass a custom value to align with antd's `xs/sm/md/lg/xl/xxl` if needed
 * (e.g. 768 for `<md`, 992 for `<lg`).
 */
export const useMobileMode = (breakpoint: number = 1024): boolean => {
    const evaluate = () => typeof window !== 'undefined' && window.innerWidth <= breakpoint

    const [isMobile, setIsMobile] = useState<boolean>(evaluate)

    useEffect(() => {
        if (typeof window === 'undefined') return
        const handleResize = () => setIsMobile(evaluate())
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [breakpoint])

    return isMobile
}
